module.exports = __webpack_public_path__ + "img/组 16.fcb43ef7.png";